import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import type { PropsWithChildren } from 'react'
import {
  labelWithIcon,
  labelWithIconText,
  labelWithIconTruncate
} from './LabelWithIcon.css'

type LabelWithIconProps = PropsWithChildren<{
  icon?: IconProp
  truncate?: boolean
}>

export const LabelWithIcon = ({
  icon,
  children,
  truncate = false
}: LabelWithIconProps) => (
  <span className={clsx(labelWithIcon, truncate && labelWithIconTruncate)}>
    {icon && <FontAwesomeIcon icon={icon} />}
    <span className={labelWithIconText}>{children}</span>
  </span>
)
